import { Utils } from '@genial/utils';

export const labelTypesMask = {
  number: {
    defaultMask: <T>(value: T) => value,
    mask: <T>(value: T) => value,
    unmask: <T>(value: T) => Number(value),
  },
  money: {
    defaultMask: (value?: number) => {
      if (value === undefined) {
        return undefined;
      }
      return Utils.Mask.Money(value);
    },
    mask: Utils.Mask.InputMoney,
    unmask: (value?: string) => {
      if (value === undefined) {
        return NaN;
      }
      return Utils.Unmask.Money(value);
    },
  },
  percentage: {
    defaultMask: Utils.Mask.Percentage,
    mask: (value: number | string) => {
      if (value === undefined) {
        return '';
      }
      if (`${value}`.length === 1) {
        return Utils.Mask.InputPercentage(Number(value) / 100);
      }
      return Utils.Mask.InputPercentage(value);
    },
    unmask: (value?: string) => {
      if (!value) {
        return NaN;
      }
      return Utils.Unmask.Percentage(value);
    },
  },
};

export type LabelTypes = keyof typeof labelTypesMask;
